export const getNetworkActiveFlag = (network) => {
  if (!network || typeof network !== 'object') return undefined;

  if (network.isActive != null) return network.isActive;
  if (network.is_active != null) return network.is_active;
  if (network.active != null) return network.active;

  const activeKey = Object.keys(network).find((key) => key.toLowerCase() === 'isactive');
  return activeKey ? network[activeKey] : undefined;
};

export const isCoboChainActive = (network) => {
  const value = getNetworkActiveFlag(network);

  if (value === false || value === 0) return false;

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (normalized === 'false' || normalized === '0') return false;
    return normalized === 'true' || normalized === '1';
  }

  return value === true || value === 1;
};

export const filterActiveCoboChains = (chains) =>
  (Array.isArray(chains) ? chains : []).filter(isCoboChainActive);

/** Same network visibility as deposit page — use deposit-assets isActive as source of truth */
export const applyDepositActiveFilterToWithdrawChains = (
  assetSymbol,
  withdrawChains,
  depositAssetsBySymbol = {}
) => {
  const coin = depositAssetsBySymbol[String(assetSymbol || '').toUpperCase()];
  const depositActiveChainIds = new Set(
    filterActiveCoboChains(coin?.cobo_chain_list).map((chain) => chain?.chainId)
  );

  const chains = Array.isArray(withdrawChains) ? withdrawChains : [];

  if (depositActiveChainIds.size === 0) {
    return filterActiveCoboChains(chains);
  }

  return chains
    .filter((chain) => depositActiveChainIds.has(chain?.chainId))
    .map((chain) => ({ ...chain, isActive: true }));
};

export const getDepositActiveChainsForCoin = (assetSymbol, depositAssetsBySymbol = {}) => {
  const coin = depositAssetsBySymbol[String(assetSymbol || '').toUpperCase()];
  return filterActiveCoboChains(coin?.cobo_chain_list);
};
